// 모바일 기기 감지 유틸리티
export const isMobileDevice = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// 앱 다운로드 핸들러 (모바일에서는 직접 다운로드, 데스크톱에서는 QR 팝업)
export const handleAppDownload = (setQRPopupOpen: (open: boolean) => void) => {
  if (isMobileDevice()) {
    // 모바일에서는 바로 앱 다운로드 페이지로 이동
    window.open('https://about.ponpish.co.kr/hidden/app-download', '_blank');
  } else {
    // 데스크톱에서는 QR 팝업 표시
    setQRPopupOpen(true);
  }
};

// Shop 클릭 핸들러 (모바일에서는 QR 팝업, 데스크톱에서는 웹사이트)
export const handleShopClick = (setQRPopupOpen: (open: boolean) => void) => {
  window.open('http://ponpish.co.kr/', '_blank');
  // if (isMobileDevice()) {
  //   setQRPopupOpen(true);
  // // } else {
  // window.open('http://ponpish.co.kr/', '_blank');
  // }
};
